<template>
  <div class="fill-height"
    :style="[
      {'background-image': `url('${require('@/assets/background-login.jpg')}')`},
      {'background-repeat': 'repeat'}
    ]"
  >
    <strategio-app-bar></strategio-app-bar>
    <v-content style="height:100vh">
      <div style="max-height:100%; overflow:auto">
        <v-container>
          <v-layout row wrap>
            <div>
              <v-layout align-center row>
                <v-flex align-center>
                  <v-btn flat icon color="white" @click="goBack()">
                    <v-icon medium>arrow_back</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex align-center>
                  <span style="color:white;font-size:32px;font-weight:700;">
                    Favoritos
                  </span>
                </v-flex>
              </v-layout>
            </div>
            <v-flex xs12 sm12 md12 lg12 xl12 >
              <report-list-item 
                v-for="f in favorites" 
                :key="f.reportID" 
                :report-data="f"
                favorites-page
              />
            </v-flex>
          </v-layout>
        </v-container>

      </div>
    </v-content>
    <custom-snack-bar></custom-snack-bar>

  </div>
</template>

<script>
import eventBus from '../utils/eventBus'

import StrategioAppBar from '../components/header-bar/strategio-app-bar.vue'
import ReportListItem from '../components/reports/report-list-item.vue'
import reportsStorage from '../storage/reportsStorage'

import CustomSnackBar from '../components/snackbars/custom-snack-bar.vue'

export default {
  name: 'favorites',
  data () {
    return {
      favorites: []
    }
  },
  mounted () {
    reportsStorage.getData({
      forceLoad: false,
      onSuccess: (data) => {
        const _favorites = []
        console.log(data)
        data.map((item, index) => {
          if (item.isFavorite) {
            _favorites.push(item)
          }
        })
        this.favorites = _favorites
      },
      onError: (error) => {
        let message = 'Error desconocido'
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          console.log(error.response.data)
          // console.log(error.response.status);
          // console.log(error.response.headers);
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          console.log(error.request)
          message = 'No pudimos obtener respuesta del servidor'
        } else {
          // Something happened in setting up the request that triggered an Error
          message = `Error desconocido: ${error.message}`
        }
        eventBus.$emit('open-custom-snack-bar', {message, itsOk: false})
      }
    })
  },
  methods: {
    goBack () {
      this.$router.push('/0')
    }
  },
  components: {
    ReportListItem,
    StrategioAppBar,
    CustomSnackBar
  }
}
</script>



// WEBPACK FOOTER //
// src/routes/favorites.vue